import { ethers as o } from "ethers";
import { DOBContractAbi as n } from "@deorderbook/contracts/abi";
import { DOBAddress as e } from "@deorderbook/contracts";
import { signer as c, provider as i } from "./provider.mjs";
const s = () => new o.Contract(e, n), C = (t = !1) => {
  const r = s();
  return t ? r.connect(c) : r.connect(i);
};
export {
  s as initDOBContract,
  C as useDOBContract
};
//# sourceMappingURL=dobContract.mjs.map
